import Swiper, { Navigation, Autoplay, A11y, Pagination, Mousewheel, FreeMode, Grid, EffectCoverflow } from 'swiper';
Swiper.use([Navigation, Autoplay, A11y, Pagination, Mousewheel, FreeMode, Grid, EffectCoverflow]);

// Swipers
if (jQuery('.swiper-link-cards').length) {
  new Swiper('.swiper-link-cards', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 30,
    enabled: true,
    autoplay: {
      delay: 7500,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
        enabled: false,
      },
      575: {
        slidesPerView: 2,
        enabled: true,
      },
    },
  })
}

if (jQuery('.swiper-link-cards-wide').length) {
  new Swiper('.swiper-link-cards-wide', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 30,
    enabled: true,
    autoplay: {
      delay: 7500,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      1199: {
        slidesPerView: 4,
        enabled: false,
      },
      991: {
        slidesPerView: 3,
        enabled: true,
      },
      575: {
        slidesPerView: 2,
        enabled: true,
      },
    },
  })
}

if (jQuery('.swiper-link-cards-unlimited').length) {
  new Swiper('.swiper-link-cards-unlimited', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 30,
    autoplay: {
      delay: 7500,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      991: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
    },
  })
}

if (jQuery('.swiper-testimonials').length) {
  new Swiper('.swiper-testimonials', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 8000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  });
}

if (jQuery('.swiper-testimonials-blank').length) {
  new Swiper('.swiper-testimonials-blank', {
    loop: true,
    speed: 500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletElement: 'button',
    },
    a11y: {
      enabled: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1199: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });
}

if (jQuery('.swiper-media').length) {
  new Swiper('.swiper-media', {
    slidesPerView: 1.5,
    loop: false,
    mousewheel: {
      releaseOnEdges: true,
    },
    freeMode: true,
    grid: {
      rows: 2,
      fill: 'column',
    },
    spaceBetween: 20,
    enabled: false,
    breakpoints: {
      2100: {
        slidesPerView: 4.6,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 30,
        enabled: true,
      },
      1740: {
        slidesPerView: 3.6,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 30,
        enabled: true,
      },
      1680: {
        slidesPerView: 3.2,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 30,
        enabled: true,
      },
      1510: {
        slidesPerView: 2.8,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 20,
        enabled: true,
      },
      1366: {
        slidesPerView: 2.4,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 20,
        enabled: true,
      },
      1250: {
        slidesPerView: 2.2,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 20,
        enabled: true,
      },
      1120: {
        slidesPerView: 1.8,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 20,
        enabled: true,
      },
      991: {
        slidesPerView: 1.4,
        grid: {
          rows: 2,
          fill: 'column',
        },
        spaceBetween: 20,
        enabled: true,
      },
    },
  });
}

if (jQuery('.swiper-media-small').length) {
  new Swiper('.swiper-media-small', {
    slidesPerView: 1.6,
    loop: false,
    mousewheel: {
      releaseOnEdges: true,
    },
    freeMode: true,
    spaceBetween: 20,
    breakpoints: {
      1366: {
        slidesPerView: 4.6,
      },
      991: {
        slidesPerView: 3.6,
      },
      575: {
        slidesPerView: 2.6,
      },
    },
  });
}
